import ExcelJS from "exceljs";
import { CONTRACT_ITEM_IMPORT_COLUMNS } from "../utils/validateContractItemsImport";

// Chuẩn hóa tiêu đề cột để so khớp không phụ thuộc dấu và khoảng trắng.
const normalizeHeader = (value) =>
  (value || "")
    .toString()
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ");

// Lấy giá trị thực của ô Excel, bao gồm công thức và rich text.
const getCellValue = (cell) => {
  const value = cell?.value;
  if (value && typeof value === "object") {
    if (value.result !== undefined) return value.result;
    if (value.text !== undefined) return value.text;
    if (Array.isArray(value.richText)) {
      return value.richText.map((part) => part.text).join("");
    }
  }
  return value;
};

// Đọc file Excel import hạng mục hợp đồng thành danh sách dòng dữ liệu.
const readWorksheet = (worksheet) => {
  let headerRow = null;
  const columnIndexByKey = {};
  const expectedHeaders = CONTRACT_ITEM_IMPORT_COLUMNS.map((column) => ({
    ...column,
    normalizedHeaders: [column.header, ...(column.aliases || [])].map(normalizeHeader),
  }));

  worksheet.eachRow((row, rowNumber) => {
    if (headerRow) return;

    const normalizedCells = [];
    row.eachCell({ includeEmpty: false }, (cell, colNumber) => {
      normalizedCells[colNumber] = normalizeHeader(getCellValue(cell));
    });

    const hasImportCode = expectedHeaders
      .find((column) => column.key === "importCode")
      ?.normalizedHeaders.some((header) => normalizedCells.includes(header));
    const hasName = expectedHeaders
      .find((column) => column.key === "itemName")
      ?.normalizedHeaders.some((header) => normalizedCells.includes(header));

    if (!hasImportCode || !hasName) return;

    headerRow = rowNumber;
    expectedHeaders.forEach((column) => {
      const index = normalizedCells.findIndex((value) =>
        column.normalizedHeaders.includes(value),
      );
      if (index > -1) columnIndexByKey[column.key] = index;
    });
  });

  if (!headerRow) {
    throw new Error(
      "Không tìm thấy dòng tiêu đề có cột STT import và Hạng mục công việc",
    );
  }

  const rows = [];
  for (let rowNumber = headerRow + 1; rowNumber <= worksheet.rowCount; rowNumber += 1) {
    const worksheetRow = worksheet.getRow(rowNumber);
    const rowData = { rowNumber };
    CONTRACT_ITEM_IMPORT_COLUMNS.forEach((column) => {
      const colNumber = columnIndexByKey[column.key];
      rowData[column.key] = colNumber
        ? getCellValue(worksheetRow.getCell(colNumber))
        : "";
    });

    const hasValue = CONTRACT_ITEM_IMPORT_COLUMNS.some((column) => {
      const value = rowData[column.key];
      return value !== null && value !== undefined && value.toString().trim() !== "";
    });
    if (hasValue) rows.push(rowData);
  }

  return rows;
};

export const readContractItemsImportSheets = async (file) => {
  const workbook = new ExcelJS.Workbook();
  await workbook.xlsx.load(await file.arrayBuffer());
  if (!workbook.worksheets.length) throw new Error("File Excel không có worksheet hợp lệ");
  // The existing app template contains reference/version sheets, not item data.
  const referenceSheets = new Set(["danh_muc_co_dinh", "phien_ban"]);
  return workbook.worksheets.filter((sheet) => sheet.state !== "veryHidden" && !referenceSheets.has(sheet.name.toLowerCase())).map((sheet) => {
    try { return { sheetName: sheet.name, rows: readWorksheet(sheet) }; }
    catch (error) { throw new Error(`Sheet "${sheet.name}": ${error.message}`); }
  });
};
export const readContractItemsImportExcel = async (file) => (await readContractItemsImportSheets(file))[0]?.rows || [];
export default readContractItemsImportExcel;
